import type { MakeRouteMatchUnion } from '@tanstack/react-router';
import { useParentMatches } from '@tanstack/react-router';

import type { BreadcrumbItem } from '#/components/ui/Breadcrumbs';

export function useBreadcrumbs(): BreadcrumbItem[] {
  return useParentMatches({
    select: (matches) =>
      matches
        .map(resolveBreadcrumb)
        .filter((item): item is BreadcrumbItem => item !== null),
  });
}

function resolveBreadcrumb(match: MakeRouteMatchUnion) {
  const breadcrumb = match.staticData.breadcrumb ?? match.context.breadcrumb;

  if (!breadcrumb) {
    return null;
  }

  return {
    label: breadcrumb,
    href: match.pathname,
  };
}
